<template>
    <el-dialog
        :visible.sync="loginVisible"
        :show-close="false"
        center
        width="500px"
        :before-close="handleClose">
        <div class="login">
            <div class="login_title">
                <img src="../assets/login/login_logo.png" alt="">
            </div>
            <div class="login_input">
                <img class="login_input_img1" src="../assets/login/login_phone.png" >
                <el-input v-model="loginForm.mobile" placeholder="请填写手机号"></el-input>
            </div>
            <div class="login_input">
                <img class="login_input_img1" src="../assets/login/login_reset.png" >
                <el-input v-model="loginForm.password" type="password" placeholder="请填写账号密码"></el-input>
            </div>
            <el-button class="login_btn" type="primary" @click="login">登录</el-button>
            <div class="login_handle">
                <!-- registerVisible,loginVisible,resetVisible -->
                <el-button type="text" @click="$emit('login','resetVisible');">忘记密码</el-button>
                <el-button type="text" @click="$emit('login','registerVisible');">注册账号</el-button>
            </div>
            <div class="login_type" @click="$emit('login','wxLoginVisible');">
                <img src="../assets/login/login_wechati.png" alt="">
                <p><span>微信扫码登录</span></p>
            </div>
        </div>
        

    </el-dialog>
   
</template>

<script>
export default {
    props:["loginVisible","loginPath"],
   data (){
       return {
           loginForm:{
               mobile:'',
                code:''
           }
           
       }
   },
   components: {
       
   },
   watch: {
       
   },
   computed: { 
       
   },
   methods: { 
       handleClose(){
           this.$emit("update:loginVisible",false)
       },
       login(){
           if(!this.isPhoneNo(this.loginForm.mobile)){
                this.$message.error('请填写手机号');
                return
            }
            if(!this.loginForm.password){
                this.$message.error('请输入密码');
                return
            }
            this.$post('Login',this.loginForm)
                .then(data => {
                    this.$message.success('登录成功！');
                    localStorage.setItem('userMessage',JSON.stringify(Object.assign(data,data.user)));
                    this.$eventBus.$emit('changeUserInfo',data);
                    this.handleClose();
                    if(this.loginPath){
                        this.$router.push(this.loginPath);
                    }else{
                        this.$router.push({path:'/message'});
                    }
                    
                } , error => {
                    this.$message.error(error);
                });
           
       },
       test(){
           console.log(this.userInfo);
       },
        isPhoneNo(phone) {
            var pattern = /^[1][3-9][0-9]{9}$/;
            return pattern.test(phone);
        }  
   },
   created() {
       
   },
   mounted() {
       
   }
}
</script>

<style scoped lang='less'>
.login{
    padding: 0 35px;
    &_title{
        text-align: center;
        img{
            width:132px;
            margin-top:10px;
        }
    }
    &_input{
        margin-top:24px;
        position: relative;
        &_img1{
            width:20px;
            position: absolute;
            top: 16px;
            left: 16px;
            z-index:1;
        }
        /deep/ input{
            height:60px;
            font-size:20px;
            padding-left:54px;
        }
        
    }
    &_input2{
        margin-top:24px;
        position: relative;
        /deep/ input{
            height:60px;
            font-size:20px;
            padding-left:54px;
            padding-right:128px;
        }
        &_img2{
            width:30px;
            position: absolute;
            top: 16px;
            left: 14px;
            z-index:1;
        }
        &_code{
            height:34px;
            width:128px;
            border-left:1px solid #CFD7E0;
            padding-left:8px;
            position: absolute;
            right:0;
            top:13px;
            &_get{
                font-size: 20px;
                line-height: 34px;
                color:#009AFF;
                cursor: pointer;
            }
        }
    }
    &_btn{
        width:100%;
        margin-top:26px;
    }
    /deep/ &_btn.el-button{
        height: 54px;
        font-size: 18px;
        background:#5999FF;
    }
    &_handle{
        display: flex;
        justify-content: space-between;
        padding: 10px 0 30px 0;
        border-bottom:1px solid #F5F5F5;
        /deep/ .el-button--text{
            font-size:18px;
            color:#009AFF;
        }
    }
    &_type{
        text-align: center;
        margin-top:23px;
        img{
            width:58px;
            height: 46px;
            cursor: pointer;
        }
        p{
            color:#333;
            span{
                cursor: pointer;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/login.vue